/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { CourseStudentUpdateRequestOrderId } from './courseStudentUpdateRequestOrderId';
import type { CourseStudentUpdateRequestState } from './courseStudentUpdateRequestState';
import type { CourseStudentUpdateRequestEnrollmentDate } from './courseStudentUpdateRequestEnrollmentDate';
import type { CourseStudentUpdateRequestAccessibleModuleIds } from './courseStudentUpdateRequestAccessibleModuleIds';
import type { CourseStudentUpdateRequestExtraModuleIds } from './courseStudentUpdateRequestExtraModuleIds';

/**
 * Request model for updating student enrollment details
 */
export interface CourseStudentUpdateRequest {
  orderId?: CourseStudentUpdateRequestOrderId;
  state?: CourseStudentUpdateRequestState;
  enrollmentDate?: CourseStudentUpdateRequestEnrollmentDate;
  accessibleModuleIds?: CourseStudentUpdateRequestAccessibleModuleIds;
  extraModuleIds?: CourseStudentUpdateRequestExtraModuleIds;
}
